/**
 * Sets all elements within the same row (based on top offset) to the same height.
 * Can be applied to any selector group (e.g., all elements sharing the same data attribute).
 * Automatically recalculates on page load and window resize.
 *
 * @param {string} container - A CSS selector string that selects the elements to be equalized in height.
 */
export const sameHeight = (container) => {
    const setHeight = (el, val) => {
        if (typeof val === 'function') val = val();
        if (typeof val === 'string') el.style.height = val;
        else el.style.height = val + 'px';
    };

    const sameHeightCalc = () => {
        var currentTallest = 0,
            currentRowStart = 0,
            rowDivs = [],
            currentDiv,
            topPostion = 0;

        Array.from(document.querySelectorAll(container)).forEach((el) => {
            el.style.height = 'auto';
            topPostion = el.offsetTop;

            if (currentRowStart !== topPostion) {
                for (currentDiv = 0; currentDiv < rowDivs.length; currentDiv++) {
                    setHeight(rowDivs[currentDiv], currentTallest);
                }
                rowDivs.length = 0;
                currentRowStart = topPostion;
                currentTallest = parseFloat(getComputedStyle(el, null).height.replace('px', ''));
                rowDivs.push(el);
            } else {
                rowDivs.push(el);
                currentTallest =
                    currentTallest < parseFloat(getComputedStyle(el, null).height.replace('px', ''))
                        ? parseFloat(getComputedStyle(el, null).height.replace('px', ''))
                        : currentTallest;
            }

            for (currentDiv = 0; currentDiv < rowDivs.length; currentDiv++) {
                setHeight(rowDivs[currentDiv], currentTallest);
            }
        });
    };

    window.addEventListener('load', function () {
        sameHeightCalc(container);
    });

    let windowWidth = window.innerWidth;

    window.addEventListener('resize', function () {
        if (window.innerWidth !== windowWidth) {
            windowWidth = window.innerWidth;
            sameHeightCalc(container);
        }
    });
};

/**
 * Initializes sameHeight functionality for all groups defined by the `data-same-height` attribute.
 * Finds unique attribute values and applies height equalization within each group.
 */
const allElements = document.querySelectorAll('[data-same-height]');
const groupNames = new Set();

allElements.forEach((el) => {
    groupNames.add(el.getAttribute('data-same-height'));
});

groupNames.forEach((groupName) => {
    sameHeight('[data-same-height="' + groupName + '"]');
});

// 👇 Make it global if running in browser
if (typeof window !== 'undefined') {
    window.sameHeight = sameHeight;
}
